module.exports = {
  "account_page": null,
  "shopping_cart_page": null,
  "not_found_page": [
    {
      "language": "nb-NO",
      "slug": "/not-found",
      "robots": "index,follow"
    },
    {
      "language": "en-US",
      "slug": "/en-US/not-found",
      "robots": "index,follow"
    }
  ]
}